import React from 'react';

import { TextComponentFragment } from '../../../../graphql.schema';
import { ContentBlock } from '../../ContentBlock/ContentBlock';

import * as styles from '../index.module.scss';

export const StrapiTextComponent: React.FC<TextComponentFragment> = ({ content, link }) => {
  return (
    <div className={styles.pageComponent}>
      <ContentBlock content={content} button={link ?? undefined} isFluid />
    </div>
  );
};
